import _ from 'lodash';
import { CLOSE_NOTIFICATION, NEW_NOTIFICATION, REMOVE_NOTIFICATION } from '../actions/types/NotificationTypes';
import NotificationModel from '../../models/NotificationModel';
import NotificationCollection from '../../models/NotificationCollection';

export default (state = [], action) => {
  switch (action.type) {
  case NEW_NOTIFICATION:
    return _.concat(state, new NotificationModel(action.payload));

  case CLOSE_NOTIFICATION:
    return _.map(state, notification => (notification.id === action.payload.id ? new NotificationModel(notification).setIsClosing(true) : notification));

  case REMOVE_NOTIFICATION:
    return _.without(state, new NotificationCollection(state).find(action.payload.id));

  default:
    return state;
  }
};
